import { FC, HTMLAttributes, ReactElement } from 'react';

import { TokensSpacingType } from '../models';
import { makeClass } from '../../../utils';

export interface SpaceProps extends HTMLAttributes<HTMLDivElement> {
  value?: TokensSpacingType;
  direction?: 'horizontal' | 'vertical';
}

const Horizontal = (props: SpaceProps) => (
  <Space {...props} direction='horizontal' />
);

const Vertical = (props: SpaceProps) => (
  <Space {...props} direction='vertical' />
);

type NamedExportsType = {
  H: typeof Horizontal;
  V: typeof Vertical;
};

/**
 * @deprecated This is a internal component that will be removed in the upcoming versions. Please use css variables like `--spacing-xs` instead.
 * The `<Space />` component extends `HTMLAttributes<HTMLDivElement>`.
 * @param props
 * @constructor
 * @example
 * <Space value='xl' direction='vertical' />
 */
const Space: FC<SpaceProps> & NamedExportsType = (
  props: SpaceProps
): ReactElement => {
  const { className, value, direction, ...rest } = props;
  const classes = makeClass([
    className,
    value && `sp--${value}`,
    direction === 'horizontal' ? 'pd--right' : 'pd--bottom',
    `j-Space__${direction}`,
    'j-Space'
  ]);
  return <span className={classes} {...rest} />;
};
Space.H = Horizontal;
Space.V = Vertical;

Space.displayName = 'Space';
Space.defaultProps = {
  direction: 'vertical',
  value: 's'
};
export default Space;
